import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const GRID_CLASS = {
    1: "grid grid-cols-1 gap-3",
    2: "grid grid-cols-2 gap-3",
    3: "grid grid-cols-3 gap-3",
};
export function SocialSignIn({ title, providers, columns = 1, onProviderLogin, }) {
    return (_jsxs("div", { className: "space-y-3", children: [_jsxs("div", { className: "flex items-center gap-3 text-xs text-slate-400", children: [_jsx("span", { className: "h-px flex-1 bg-slate-200" }), title, _jsx("span", { className: "h-px flex-1 bg-slate-200" })] }), _jsx("div", { className: GRID_CLASS[columns], children: providers.map((provider) => (_jsxs("button", { type: "button", onClick: () => onProviderLogin(provider.id), className: [
                        "inline-flex h-10 items-center justify-center rounded-xl border",
                        "border-slate-200 bg-white px-4 text-sm font-medium text-slate-700",
                        "transition-colors hover:bg-slate-50 active:bg-slate-100",
                    ].join(" "), children: [provider.leading, provider.label] }, provider.id))) })] }));
}
